/**
 * ============================================================================
 * DizyPro ERP
 * Module : Service CRM
 * Feature: Installed Products
 *
 * File:
 * src/modules/service_crm/installed_products/constants/geographyMaster.js
 *
 * Description:
 * Geography master data used by Installed Product Management.
 *
 * Responsibilities:
 * - Countries
 * - India States
 * - India Cities
 * - Country → State → City helper methods
 *
 * NOTE:
 * These are frontend static masters.
 * Later they will be replaced by Master APIs.
 * ============================================================================
 */
/* ============================================================================
 * COUNTRIES
 * ========================================================================== */

export const COUNTRIES = [
    { value: "", label: "Select" },
    { value: "INDIA", label: "India" },
    { value: "BHUTAN", label: "Bhutan" },
    { value: "NEPAL", label: "Nepal" },
    { value: "BANGLADESH", label: "Bangladesh" },
    { value: "KENYA", label: "Kenya" },
    { value: "TANZANIA", label: "Tanzania" },
    { value: "UGANDA", label: "Uganda" },
    { value: "ZAMBIA", label: "Zambia" },
    { value: "CONGO", label: "Congo" },
    { value: "NIGERIA", label: "Nigeria" },
    { value: "OTHER", label: "Other" },
    { value: "NA", label: "NA" }
];
/* ============================================================================
 * INDIA STATES
 * ========================================================================== */

export const INDIA_STATES = [
    { value: "", label: "Select" },

    // States

    { value: "ANDHRA_PRADESH", label: "Andhra Pradesh" },
    { value: "ARUNACHAL_PRADESH", label: "Arunachal Pradesh" },
    { value: "ASSAM", label: "Assam" },
    { value: "BIHAR", label: "Bihar" },
    { value: "CHHATTISGARH", label: "Chhattisgarh" },
    { value: "GOA", label: "Goa" },
    { value: "GUJARAT", label: "Gujarat" },
    { value: "HARYANA", label: "Haryana" },
    { value: "HIMACHAL_PRADESH", label: "Himachal Pradesh" },
    { value: "JHARKHAND", label: "Jharkhand" },
    { value: "KARNATAKA", label: "Karnataka" },
    { value: "KERALA", label: "Kerala" },
    { value: "MADHYA_PRADESH", label: "Madhya Pradesh" },
    { value: "MAHARASHTRA", label: "Maharashtra" },
    { value: "MANIPUR", label: "Manipur" },
    { value: "MEGHALAYA", label: "Meghalaya" },
    { value: "MIZORAM", label: "Mizoram" },
    { value: "NAGALAND", label: "Nagaland" },
    { value: "ODISHA", label: "Odisha" },
    { value: "PUNJAB", label: "Punjab" },
    { value: "RAJASTHAN", label: "Rajasthan" },
    { value: "SIKKIM", label: "Sikkim" },
    { value: "TAMIL_NADU", label: "Tamil Nadu" },
    { value: "TELANGANA", label: "Telangana" },
    { value: "TRIPURA", label: "Tripura" },
    { value: "UTTAR_PRADESH", label: "Uttar Pradesh" },
    { value: "UTTARAKHAND", label: "Uttarakhand" },
    { value: "WEST_BENGAL", label: "West Bengal" },

    // Union Territories

    {
        value: "ANDAMAN_NICOBAR_ISLANDS",
        label: "Andaman & Nicobar Islands"
    },
    {
        value: "CHANDIGARH",
        label: "Chandigarh"
    },
    {
        value: "DADRA_NAGAR_HAVELI_DAMAN_DIU",
        label: "Dadra & Nagar Haveli and Daman & Diu"
    },
    {
        value: "DELHI",
        label: "Delhi"
    },
    {
        value: "JAMMU_KASHMIR",
        label: "Jammu & Kashmir"
    },
    {
        value: "LADAKH",
        label: "Ladakh"
    },
    {
        value: "LAKSHADWEEP",
        label: "Lakshadweep"
    },
    {
        value: "PUDUCHERRY",
        label: "Puducherry"
    },

    { value: "NA", label: "NA" }
];
/* ============================================================================
 * INDIA CITIES
 * ========================================================================== */

export const INDIA_CITIES = {
        KARNATAKA: [
        "Bengaluru",
        "Mysuru",
        "Mangaluru",
        "Hubballi",
        "Dharwad",
        "Belagavi",
        "Ballari",
        "Shivamogga",
        "Tumakuru",
        "Davanagere",
        "Udupi",
        "Vijayapura",
        "Raichur",
        "Bidar",
        "Kalaburagi",
        "Hassan",
        "Chitradurga",
        "Hosapete",
        "Kolar",
        "Mandya"
    ],

    TAMIL_NADU: [
        "Chennai",
        "Coimbatore",
        "Madurai",
        "Salem",
        "Tiruchirappalli",
        "Tirunelveli",
        "Erode",
        "Vellore",
        "Thoothukudi",
        "Dindigul",
        "Thanjavur",
        "Karur",
        "Namakkal",
        "Hosur",
        "Kanchipuram",
        "Cuddalore",
        "Nagapattinam",
        "Sivakasi",
        "Nagercoil",
        "Pollachi"
    ],

    KERALA: [
        "Thiruvananthapuram",
        "Kochi",
        "Kozhikode",
        "Thrissur",
        "Kannur",
        "Kollam",
        "Alappuzha",
        "Palakkad",
        "Malappuram",
        "Kottayam",
        "Pathanamthitta",
        "Idukki",
        "Kasaragod",
        "Wayanad",
        "Ponnani"
    ],

    ANDHRA_PRADESH: [
        "Visakhapatnam",
        "Vijayawada",
        "Guntur",
        "Tirupati",
        "Kakinada",
        "Rajahmundry",
        "Nellore",
        "Kadapa",
        "Anantapur",
        "Kurnool",
        "Eluru",
        "Ongole",
        "Machilipatnam",
        "Chittoor",
        "Srikakulam"
    ],
        TELANGANA: [
        "Hyderabad",
        "Warangal",
        "Nizamabad",
        "Karimnagar",
        "Khammam",
        "Ramagundam",
        "Mahabubnagar",
        "Nalgonda",
        "Adilabad",
        "Suryapet",
        "Siddipet",
        "Medak",
        "Sangareddy",
        "Jagtial",
        "Mancherial"
    ],

    GOA: [
        "Panaji",
        "Margao",
        "Vasco da Gama",
        "Mapusa",
        "Ponda",
        "Bicholim",
        "Curchorem",
        "Canacona",
        "Valpoi",
        "Quepem"
    ],

    MAHARASHTRA: [
        "Mumbai",
        "Pune",
        "Nagpur",
        "Nashik",
        "Aurangabad",
        "Thane",
        "Navi Mumbai",
        "Kolhapur",
        "Solapur",
        "Sangli",
        "Satara",
        "Jalgaon",
        "Ahmednagar",
        "Amravati",
        "Akola",
        "Latur",
        "Chandrapur",
        "Ratnagiri",
        "Yavatmal",
        "Wardha"
    ],

    GUJARAT: [
        "Ahmedabad",
        "Surat",
        "Vadodara",
        "Rajkot",
        "Bhavnagar",
        "Jamnagar",
        "Junagadh",
        "Anand",
        "Gandhinagar",
        "Mehsana",
        "Morbi",
        "Bharuch",
        "Navsari",
        "Palanpur",
        "Porbandar",
        "Godhra",
        "Valsad",
        "Veraval",
        "Bhuj",
        "Amreli"
    ],

    MADHYA_PRADESH: [
        "Bhopal",
        "Indore",
        "Jabalpur",
        "Gwalior",
        "Ujjain",
        "Sagar",
        "Satna",
        "Rewa",
        "Katni",
        "Chhindwara",
        "Ratlam",
        "Dewas",
        "Khandwa",
        "Neemuch",
        "Mandsaur",
        "Vidisha",
        "Shivpuri",
        "Sehore",
        "Singrauli",
        "Hoshangabad"
    ],
        RAJASTHAN: [
        "Jaipur",
        "Jodhpur",
        "Udaipur",
        "Kota",
        "Ajmer",
        "Bikaner",
        "Alwar",
        "Bharatpur",
        "Sikar",
        "Pali",
        "Bhilwara",
        "Chittorgarh",
        "Sri Ganganagar",
        "Hanumangarh",
        "Barmer",
        "Jaisalmer",
        "Tonk",
        "Nagaur",
        "Dausa",
        "Jhunjhunu"
    ],

    PUNJAB: [
        "Ludhiana",
        "Amritsar",
        "Jalandhar",
        "Patiala",
        "Bathinda",
        "Mohali",
        "Hoshiarpur",
        "Pathankot",
        "Moga",
        "Batala",
        "Kapurthala",
        "Firozpur",
        "Faridkot",
        "Sangrur",
        "Barnala"
    ],

    HARYANA: [
        "Gurugram",
        "Faridabad",
        "Panipat",
        "Ambala",
        "Hisar",
        "Karnal",
        "Rohtak",
        "Sonipat",
        "Yamunanagar",
        "Panchkula",
        "Bhiwani",
        "Sirsa",
        "Rewari",
        "Jhajjar",
        "Kaithal"
    ],

    HIMACHAL_PRADESH: [
        "Shimla",
        "Dharamshala",
        "Solan",
        "Mandi",
        "Kullu",
        "Hamirpur",
        "Bilaspur",
        "Chamba",
        "Una",
        "Nahan",
        "Palampur",
        "Kangra",
        "Sundarnagar",
        "Manali",
        "Keylong"
    ],

    UTTARAKHAND: [
        "Dehradun",
        "Haridwar",
        "Rishikesh",
        "Haldwani",
        "Roorkee",
        "Rudrapur",
        "Kashipur",
        "Nainital",
        "Pithoragarh",
        "Almora",
        "Pauri",
        "Tehri",
        "Chamoli",
        "Uttarkashi",
        "Bageshwar"
    ],
        UTTAR_PRADESH: [
        "Lucknow",
        "Kanpur",
        "Varanasi",
        "Agra",
        "Prayagraj",
        "Ghaziabad",
        "Noida",
        "Meerut",
        "Bareilly",
        "Aligarh",
        "Moradabad",
        "Gorakhpur",
        "Jhansi",
        "Mathura",
        "Ayodhya",
        "Saharanpur",
        "Muzaffarnagar",
        "Firozabad",
        "Etawah",
        "Rampur"
    ],

    BIHAR: [
        "Patna",
        "Gaya",
        "Muzaffarpur",
        "Bhagalpur",
        "Darbhanga",
        "Purnia",
        "Begusarai",
        "Ara",
        "Bihar Sharif",
        "Katihar",
        "Munger",
        "Samastipur",
        "Motihari",
        "Sasaram",
        "Siwan"
    ],

    JHARKHAND: [
        "Ranchi",
        "Jamshedpur",
        "Dhanbad",
        "Bokaro",
        "Deoghar",
        "Hazaribagh",
        "Giridih",
        "Ramgarh",
        "Medininagar",
        "Dumka",
        "Chaibasa",
        "Godda",
        "Pakur",
        "Lohardaga",
        "Khunti"
    ],

    CHHATTISGARH: [
        "Raipur",
        "Bhilai",
        "Bilaspur",
        "Korba",
        "Durg",
        "Jagdalpur",
        "Rajnandgaon",
        "Raigarh",
        "Ambikapur",
        "Dhamtari",
        "Mahasamund",
        "Kanker",
        "Janjgir",
        "Kawardha",
        "Balod"
    ],

    ODISHA: [
        "Bhubaneswar",
        "Cuttack",
        "Rourkela",
        "Sambalpur",
        "Berhampur",
        "Balasore",
        "Puri",
        "Baripada",
        "Bhadrak",
        "Jharsuguda",
        "Jeypore",
        "Angul",
        "Kendrapara",
        "Koraput",
        "Dhenkanal"
    ],

    WEST_BENGAL: [
        "Kolkata",
        "Howrah",
        "Durgapur",
        "Asansol",
        "Siliguri",
        "Kharagpur",
        "Bardhaman",
        "Malda",
        "Haldia",
        "Darjeeling",
        "Krishnanagar",
        "Berhampore",
        "Raiganj",
        "Cooch Behar",
        "Jalpaiguri"
    ],
        ARUNACHAL_PRADESH: [
        "Itanagar",
        "Naharlagun",
        "Pasighat",
        "Tawang",
        "Bomdila",
        "Ziro",
        "Tezu",
        "Roing",
        "Aalo",
        "Namsai"
    ],

    ASSAM: [
        "Guwahati",
        "Dibrugarh",
        "Silchar",
        "Jorhat",
        "Nagaon",
        "Tezpur",
        "Tinsukia",
        "Sivasagar",
        "Bongaigaon",
        "Goalpara",
        "Dhubri",
        "Diphu",
        "North Lakhimpur",
        "Karimganj",
        "Hailakandi"
    ],

    MANIPUR: [
        "Imphal",
        "Thoubal",
        "Bishnupur",
        "Churachandpur",
        "Ukhrul",
        "Senapati",
        "Kakching",
        "Tamenglong",
        "Jiribam",
        "Moirang"
    ],

    MEGHALAYA: [
        "Shillong",
        "Tura",
        "Jowai",
        "Nongstoin",
        "Baghmara",
        "Williamnagar",
        "Resubelpara",
        "Mawkyrwat",
        "Nongpoh",
        "Khliehriat"
    ],

    MIZORAM: [
        "Aizawl",
        "Lunglei",
        "Champhai",
        "Kolasib",
        "Serchhip",
        "Saiha",
        "Lawngtlai",
        "Mamit",
        "Saitual",
        "Khawzawl"
    ],

    NAGALAND: [
        "Kohima",
        "Dimapur",
        "Mokokchung",
        "Tuensang",
        "Wokha",
        "Zunheboto",
        "Mon",
        "Phek",
        "Longleng",
        "Kiphire"
    ],

    SIKKIM: [
        "Gangtok",
        "Namchi",
        "Gyalshing",
        "Mangan",
        "Singtam",
        "Rangpo",
        "Jorethang",
        "Pakyong",
        "Ravangla",
        "Soreng"
    ],

    TRIPURA: [
        "Agartala",
        "Udaipur",
        "Dharmanagar",
        "Kailashahar",
        "Belonia",
        "Khowai",
        "Ambassa",
        "Kumarghat",
        "Sonamura",
        "Sabroom"
    ],
        DELHI: [
        "New Delhi",
        "Delhi"
    ],

    CHANDIGARH: [
        "Chandigarh"
    ],

    PUDUCHERRY: [
        "Puducherry",
        "Karaikal"
    ],

    JAMMU_KASHMIR: [
        "Srinagar",
        "Jammu",
        "Anantnag",
        "Baramulla",
        "Pulwama"
    ],

    LADAKH: [
        "Leh",
        "Kargil"
    ],

    ANDAMAN_NICOBAR_ISLANDS: [
        "Port Blair"
    ],

    LAKSHADWEEP: [
        "Kavaratti"
    ],

    DADRA_NAGAR_HAVELI_DAMAN_DIU: [
        "Daman",
        "Diu",
        "Silvassa"
    ]
};
/**
 * ============================================================================
 * PRIVATE HELPER METHODS
 * ============================================================================
 */

/**
 * Converts
 * "ANDHRA_PRADESH"
 *
 * into
 *
 * "Andhra Pradesh"
 */
const formatLabel = (value) => {

    if (!value) {
        return "";
    }

    return value
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, character => character.toUpperCase());

};

/* ============================================================================
 * HELPER METHODS
 * ========================================================================== */

/**
 * ============================================================================
 * Returns Countries
 * ============================================================================
 */
export const getCountries = () => {
    return COUNTRIES;
};




/**
 * Returns the list of states for the selected country.
 *
 * Business Rule:
 * - India → Return INDIA_STATES
 * - Other Countries → Return selected country as State
 * - NA → Return NA
 */
export const getStates = (country) => {

    if (!country) {
        return [];
    }

    if (country === "INDIA") {
        return INDIA_STATES;
    }

    if (country === "NA") {
        return [
            {
                value: "NA",
                label: "NA"
            }
        ];
    }

    return [
        {
            value: country,
            label: formatLabel(country)
        }
    ];

};
/**
 * Returns cities for the selected Country and State.
 *
 * Business Rule:
 * - India → Return mapped cities
 * - Other Countries → City = Country
 * - NA → City = NA
 */
export const getCities = (country, state) => {

    if (!country) {
        return [];
    }

    if (country !== "INDIA") {

        return [
            {
                value: country,
                label: formatLabel(country)
            }
        ];

    }

    if (!state) {
        return [];
    }

    const cities = INDIA_CITIES[state] || [];

    return cities.map(city => ({
        value: city
            .toUpperCase()
            .replace(/\./g, "")
            .replace(/\s+/g, "_"),
        label: city
    }));

};
